"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

var _angiLeadsSubNavItems = _interopRequireDefault(require("./angiLeadsSubNavItems"));

var _angiAdsSubNavItems = _interopRequireDefault(require("./angiAdsSubNavItems"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OfficeSubNav = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OfficeSubNav, _React$Component);

  var _super = _createSuper(OfficeSubNav);

  function OfficeSubNav(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, OfficeSubNav);
    _this = _super.call(this, props);
    _this.state = {
      highlightedSubNavItem: ''
    };
    return _this;
  }

  (0, _createClass2["default"])(OfficeSubNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          angiLeadsProperties = _this$props.angiLeadsProperties,
          currentSubNav = _this$props.currentSubNav,
          hasBmt = _this$props.hasBmt,
          isAdmin = _this$props.isAdmin,
          isAdvertiser = _this$props.isAdvertiser,
          selectedSubNavItem = _this$props.selectedSubNavItem,
          showHeaderSubNav = _this$props.showHeaderSubNav,
          spId = _this$props.spId,
          callTrackingFeatureFlag = _this$props.callTrackingFeatureFlag,
          showManageTeam = _this$props.showManageTeam,
          isAngiLeadsAdmin = _this$props.isAngiLeadsAdmin;
      var highlightedSubNavItem = this.state.highlightedSubNavItem;

      var highlightSubNav = function highlightSubNav(subNav) {
        _this2.setState({
          highlightedSubNavItem: subNav
        });
      };

      var subNavStyling = function subNavStyling(subNav) {
        return highlightedSubNavItem === subNav || selectedSubNavItem === subNav ? 'unified-header-sub-nav--selected-nav-item' : '';
      };

      return showHeaderSubNav ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "header-bottom unified-header-sub-nav",
        onMouseLeave: function onMouseLeave() {
          return highlightSubNav('');
        }
      }, angiLeadsProperties.isAngiLeads ? /*#__PURE__*/_react["default"].createElement(_angiLeadsSubNavItems["default"], {
        currentSubNav: currentSubNav,
        highlightSubNav: highlightSubNav,
        instantBookingEnabled: angiLeadsProperties.instantBookingEnabled,
        spId: spId,
        subNavStyling: subNavStyling,
        callTrackingFeatureFlag: callTrackingFeatureFlag,
        showManageTeam: showManageTeam,
        isAngiLeadsAdmin: isAngiLeadsAdmin
      }) : /*#__PURE__*/_react["default"].createElement(_angiAdsSubNavItems["default"], {
        currentSubNav: currentSubNav,
        hasBmt: hasBmt,
        highlightSubNav: highlightSubNav,
        isAdmin: isAdmin,
        isAdvertiser: isAdvertiser,
        spId: spId,
        subNavStyling: subNavStyling,
        callTrackingFeatureFlag: callTrackingFeatureFlag
      })) : null;
    }
  }]);
  return OfficeSubNav;
}(_react["default"].Component);

var _default = (0, _compose["default"])((0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
}), _pure["default"])(OfficeSubNav);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/officeSubNav.js
// module id = 3574
// module chunks = 25